export const NO_OUTCOMES_TITLE = "This review can't start";

/** Mirrors NO_OUTCOMES_MESSAGE in vero1_checklist_generation. */
export const NO_OUTCOMES_MESSAGE =
  "This client's Lumen formula has no outcomes configured — the review cannot start until outcomes are configured for the formula.";
